import { render, staticRenderFns } from "./page-layout.vue?vue&type=template&id=a5e94b60&"
import script from "./page-layout.vue?vue&type=script&lang=ts&"
export * from "./page-layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports